<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Company Details</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <div v-for="prop in agentProps">
      <strong>{{ prop.title }}</strong><br>
      <p>{{ item[prop.key] }}</p>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";
export default {
  props: ["item"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        name: "",
        mobile: "",
        email: "",
        notes: "",
        address: "",
      },
      // categories: []
      agentProps: [
        {title: "Name", key: 'name'},
        {title: "Mobile", key: 'mobile'},
        {title: "Email", key: 'email'},
        {title: "Address", key: 'address'},
        {title: "Notes", key: 'notes'},
      ]
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addAgentForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addAgentForm.reset();
    },
    resetValidation() {
      this.$refs.addAgentForm.resetValidation();
    },
    clearForm() {
      this.newItem.name = "";
      this.newItem.mobile = "";
      this.newItem.email = "";
      this.newItem.address = "";
      this.newItem.notes = "";
    },
    newItemDo() {
      if (this.$refs.addAgentForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/agent", this.newItem).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
